import React, { useState } from 'react'
import styled from '@mui/system/styled'
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	ClickAwayListener,
	Link,
	Stack,
	Toolbar,
} from '@mui/material'
import PropTypes from 'prop-types'
import { ReactComponent as ArrowAccordionIconWhite } from '../../media/accordion-arrow-white.svg'
import { ReactComponent as ArrowAccordionIconBlack } from '../../media/accordion-arrow-black.svg'

import Button from '../atoms/Button'

import {
	APP_BASE_URL,
	GIFT_OBJECT_URL,
	SHOP_URL,
	RECOVERY_WORKSHOP_URL,
	DIY_URL,
	BENEFIT_URL,
	DIARY,
	DIARY_URL,
	HISTORY_URL,
	HISTORY,
	REFERENCE_TEAM_URL,
	REFERENCE_TEAM,
	EMPLOYMENT_SUPPORT_URL,
	EMPLOYMENT_SUPPORT,
	PROJECTS,
	CONTACT_URL,
	CONTACT,
	PROJECTS_URL,
	ART_CRAFT_URL,
	ART_CRAFT,
	SHOP,
	RECOVERY_WORKSHOP,
	GIFT_OBJECT,
	BENEFIT,
	DIY,
} from '../../constants'

const NavigationBar = ({ white }) => {
	const color = (white && 'white') || 'black'
	const bgColor = (white && 'white') || 'black'

	const [openAccordionMenu, setOpenAccordionMenu] = useState(false)

	const handleClickAccordionMenu = (e) => {
		setOpenAccordionMenu((prev) => !prev)
	}
	const handleClickAway = (e) => {
		setOpenAccordionMenu(false)
	}

	const StyledLink = styled((props) => <Link {...props} underline="none" />)(({ theme }) => ({
		color: color,
		marginLeft: '2%',
		whiteSpace: 'nowrap',
		fontSize: 14,
		fontWeight: 600,
		cursor: 'pointer',
		position: 'relative',
		border: '1px solid transparent',
		'&:hover': {
			borderBottom: `1px solid ${color}`,
		},
	}))

	return (
		<Toolbar
			sx={(theme) => ({
				display: 'flex',
				justifyContent: 'flex-end',
				p: 0,
				mt: -1.4,
				position: 'relative',
				paddingRight: 0,
				[theme.breakpoints.up(600)]: {
					pr: 0,
				},
				[theme.breakpoints.down(1330)]: {
					justifyContent: 'space-between',
				},
			})}
		>
			<ClickAwayListener onClickAway={handleClickAway}>
				<Accordion
					sx={{ backgroundColor: 'transparent' }}
					expanded={openAccordionMenu}
					onClick={handleClickAccordionMenu}
				>
					<AccordionSummary
						sx={{
							color: color,
							fontWeight: 700,
							px: 0,
							'& .MuiAccordionSummary-expandIconWrapper': {
								ml: 1,
								mt: 0.3,
							},
						}}
						expandIcon={
							(color === 'white' && <ArrowAccordionIconWhite />) || <ArrowAccordionIconBlack />
						}
					>
						La collecterie
					</AccordionSummary>
					<AccordionDetails
						sx={{ position: 'absolute', top: 45, left: -15, bgColor: 'black', zIndex: 100 }}
					>
						<Stack
							sx={{
								bgColor: 'black',
								'& a': {
									backgroundColor: bgColor,
									color: (color === 'white' && 'black') || 'white',
									textDecoration: 'none',
									whiteSpace: 'nowrap',
									p: (theme) => theme.spacing(1.5, 4),
									borderTop: `1px solid`,
									'&:first-of-type': {
										border: 0,
									},
									'&:hover': {
										color: 'secondary.main',
									},
								},
							}}
						>
							<Link href={`${APP_BASE_URL}${DIARY_URL}`}>{DIARY}</Link>

							<Link href={`${APP_BASE_URL}${HISTORY_URL}`}>{HISTORY}</Link>
							<Link href={`${APP_BASE_URL}${REFERENCE_TEAM_URL}`}>{REFERENCE_TEAM}</Link>
							<Link href={`${APP_BASE_URL}${EMPLOYMENT_SUPPORT_URL}`}>{EMPLOYMENT_SUPPORT}</Link>
							<Link href={`${APP_BASE_URL}${PROJECTS_URL}`}>{PROJECTS}</Link>
						</Stack>
					</AccordionDetails>
				</Accordion>
			</ClickAwayListener>
			<StyledLink href={APP_BASE_URL + GIFT_OBJECT_URL}>{GIFT_OBJECT}</StyledLink>
			<StyledLink href={APP_BASE_URL + SHOP_URL}>{SHOP}</StyledLink>
			<StyledLink href={APP_BASE_URL + RECOVERY_WORKSHOP_URL}>{RECOVERY_WORKSHOP}</StyledLink>
			<StyledLink href={APP_BASE_URL + ART_CRAFT_URL}>{ART_CRAFT}</StyledLink>
			<StyledLink href={APP_BASE_URL + BENEFIT_URL}>{BENEFIT}</StyledLink>
			<StyledLink href={APP_BASE_URL + DIY_URL}>{DIY}</StyledLink>

			<Button
				href={`${APP_BASE_URL}${CONTACT_URL}`}
				label={CONTACT}
				bgColor="blue"
				color="white"
				ml="1"
			/>
		</Toolbar>
	)
}

NavigationBar.defaultProps = {
	white: false,
}

NavigationBar.propTypes = {
	white: PropTypes.bool,
}
export default NavigationBar
